<template>
  <div class="admin">

    <div class="admin-area">

      <div class="row row-gutter-20">
        <div class="col-6">
          <admin-nav></admin-nav>
        </div>
        <div class="col-18">

          <header class="admin-header cf">
            <ul class="nav nav-header cf">
              <li><router-link to="/admin/vehicles">Fahrzeuge</router-link></li>
              <li><router-link :to="'/admin/vehicles/'+this.$route.params.id">{{ vehicle.license_plate }}</router-link></li>
              <li><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/repairs'">Reparaturen</router-link></li>
              <li>Neu</li>
            </ul>
            <div class="header-actions">
              <p><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/repairs/new'" class="button button-orange button-small">Reparatur hinzufügen ›</router-link></p>
            </div>
          </header>

          <ul class="nav nav-tabs cf">
            <li><router-link :to="'/admin/vehicles/'+this.$route.params.id">Stammdaten</router-link></li>
            <li><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/reservations'">Reservierungen</router-link></li>
            <li><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/damages'">Schäden</router-link></li>
            <li class="active"><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/repairs'">Reparaturen</router-link></li>
            <!--<li><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/insurance'">Versicherung</router-link></li>-->
            <li><router-link :to="'/admin/vehicles/'+this.$route.params.id+'/documents'">Dokumente</router-link></li>
          </ul>

          <div class="admin-body">

            <form @submit="create_repair" class="form" method="post">

              <div class="row row-gutter-20">
                <div class="col-12">
                  <div class="form-wrap">
                    <label for="start">Reparatur Beginn</label>
                    <input v-model="vehicle_repair.start" class="form-input" type="datetime-local" name="start" id="start" placeholder="01.01.2020 18:00">
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-wrap">
                    <label for="end">Reparatur Ende</label>
                    <input v-model="vehicle_repair.end" class="form-input" type="datetime-local" name="end" id="end" placeholder="01.01.2020 22:00">
                  </div>
                </div>
              </div>

              <div class="form-wrap">
                <label for="description">Beschreibung</label>
                <textarea v-model="vehicle_repair.description" rows="5" class="form-input" type="text" name="description" id="description" placeholder="Art der Reparatur..."></textarea>
              </div>

              <p v-if="vehicle_repair.image"><img :src="vehicle_repair.image" width="200"></p>

              <div class="form-wrap">
                <label>Bild</label>
                <input type="file" @change="set_image">
              </div>

              <p>
                <input type="submit" value="Speichern ›" class="button button-orange button-small">
              </p>

            </form>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AdminNav from '../../../../components/admin_nav'

export default {
  name: 'new_admin_vehicle_repair',
  components: {
    AdminNav
  },
  data () {
    return {
      vehicle: {},
      vehicle_repair: {},
      temp_image: ""
    }
  },
  methods: {
    get_data() {

      axios.get(process.env.VUE_APP_BASE_API+'/v1/admin/vehicles/'+this.$route.params.id, { headers: { Authorization: this.$store.getters.getToken }})
      .then(response => {
        console.log(response);
        this.vehicle = response.data.vehicle;
      })
      .catch(error => {
        console.log(error);
      })

    },
    create_repair: function (e) {
      e.preventDefault();

      var form_data = new FormData();
      form_data.append("start", this.vehicle_repair.start);
      form_data.append("end", this.vehicle_repair.end);
      form_data.append("description", this.vehicle_repair.description);
      form_data.append("image", this.temp_image);

      axios.post(process.env.VUE_APP_BASE_API+'/v1/admin/vehicles/'+this.$route.params.id+'/repairs', form_data, { headers: { Authorization: this.$store.getters.getToken }})
      .then(response => {
        console.log(response);
        this.$notify({
          group: 'alert',
          type: 'success',
          title: 'Erfolgreich gespeichert.',
        });
        this.$router.push('/admin/vehicles/'+this.$route.params.id+'/repairs');
      })
      .catch(error => {
        error.response.data.errors.forEach(val => {
          this.$notify({
            group: 'alert',
            type: 'error',
            title: val,
          });
        })
      })

    },
    set_image(event) {
      this.temp_image = event.target.files[0];
    }
  },
  mounted () {
    this.get_data();
  }
}
</script>

<style lang="scss">

</style>
